import React from 'react';
const Stepper = _ref => {
  let {
    active,
    steps
  } = _ref;
  const stepper = steps.map((step, index) => {
    let className = '';
    const isActive = active + 1 === index + 1;
    if (isActive) {
      className = 'active';
    } else if (active + 1 > index + 1) className = 'done';
    return /*#__PURE__*/React.createElement("li", {
      key: "stepper-".concat(step.key),
      className: className,
      "aria-current": isActive
    }, /*#__PURE__*/React.createElement("span", null, step.label));
  });
  return /*#__PURE__*/React.createElement("ol", {
    className: "progressbar steps-".concat(steps.length)
  }, stepper);
};
export default Stepper;